import React from 'react';
import {IRankedVendor} from "../../../api/Analytics/Analytics.types";
import {Table} from "antd";
import NumbersUtil from "../../../global/utils/number";
import {SortOrder} from "antd/es/table/interface";

interface Props {
    data:IRankedVendor[]
}

function ContractsRankedVendorsGraph({ data }:Props){
    const tableConfig = [
        {
            key: 'vendorName', title: "Vendor Name", dataIndex: 'vendorName',
        },
        {
            key: 'dollarsPercentage', title: "Dollars Percentage", dataIndex: 'dollarsPercentage',
            render: (dollarsPercentage) => {
                let rounded = Math.round(dollarsPercentage * 100) / 100;
                return rounded + "%"
            },
            sorter: (a,b) => a.dollarsPercentage - b.dollarsPercentage,
            defaultSortOrder: "descend" as SortOrder
        },
        // {
        //     key: 'employees', title: "Employees", dataIndex: 'employees',
        // },
        {
            key: 'totalDollars', title: "Total Dollars", dataIndex: 'totalDollars',
            render: (totalDollars) => {
                return "$" + NumbersUtil.toShortened(totalDollars, 2);
            }
        },
        // {
        //     key: 'naics', title: "NAICS", dataIndex: 'naics',
        // },
        {
            key: 'actions', title: "Actions", dataIndex: 'actions',
        },
    ]
    return <Table rowKey='id' dataSource={data} columns={tableConfig}/>
}

export default ContractsRankedVendorsGraph;